<template>
  <nav v-if="isClient">
    <q-btn icon="fa fa-bars" class="md-hide lg-hide xl-hide" flat>
      <q-menu>
        <nav-items :client-id="clientId" />
      </q-menu>
    </q-btn>
    <nav-items :client-id="clientId" class="xs-hide sm-hide" />
  </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import recognition from '../auth/recognition';
import NavItems from './NavItems.vue';

export default defineComponent({
  components: { NavItems },
  computed: {
    isClient(): boolean {
      return recognition.isClient();
    },
    clientId(): number|null {
      return recognition.isClient() ? recognition.getAccountId() : null;
    },
  },
});
</script>
